import BaseService from "./base-service";

export default class DriverService extends BaseService {

    constructor() {
        super('drivers');
    }
}
